import { Navigate } from "react-router-dom";
import { RoutePermittedRole } from "shared/constants/AppConst";
import DashbardData from "./dashboardData";
import { isModuleAuthorized } from "@crema/utility/Utils";
import { Dashboard } from "@mui/icons-material";
import Error403 from "pages/errorPages/Error403";
import DashboardData from "./dashboardData";
import { exact } from "prop-types";

export const dashboardConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/dashboard/",
    exact:true,
    element: isModuleAuthorized("Dashboard") ? <DashboardData /> : <Error403 />,
  },
];
